import { render, staticRenderFns } from "./PurchaseExtensionModal.vue?vue&type=template&id=6194d3dc&"
import script from "./PurchaseExtensionModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseExtensionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports